import React from "react";
import dynamic from "next/dynamic";
import styles from "../../styles/jobsSearchPage.module.css";
import { Container, Row, Col } from "react-bootstrap";
import { GetJobInfo } from "../api/modules/Jobs";
import { useRouter } from "next/router";
import { getCookie } from "cookies-next";
import { Alert, Divider, Steps } from "antd";
import styles2 from "../../styles/JobDetail.module.css";
import JobSchema from "../../components/jobs/JobSchema";
import { UIText } from "../../components/ui/UIElements";
import { createUseStyles } from "react-jss";

const { Step } = Steps;

const MainSearchSecond = dynamic(() =>
  import("../../components/MainSearchSecond.js")
);
const JobInfoCard = dynamic(() =>
  import("../../components/jobs/jobDetailCards/JobInfoCard.js")
);
const UIHeading = dynamic(() => import("../../components/ui/common/UIHeading.js"));
const MainLayout = dynamic(() =>
  import("../../components/ui/layout/MainLayout.js")
);


function jobDetail({ jobInfo }) {
  const isCompany = getCookie("countryCode");
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const deadline = new Date(jobInfo?.Data?.ApplicationDeadline);
  deadline.setHours(0, 0, 0, 0);
  const router = useRouter();
  const Status = jobInfo?.Data?.Status == "1" && deadline >= today ? true : false;
  const style = useStyles();
  const socialImage = jobInfo?.Data?.Media?.Images?.find(
    (media) => media?.MediaURL
  )?.MediaURL;
  
  return (
    <>
      <JobSchema
        data={jobInfo?.Data}
        description={jobInfo?.Data?.JobTitle}
        title={`${jobInfo?.Data?.JobTitle} | ${jobInfo?.Data?.CompanyName}`}
        image={socialImage}
      />
      <MainLayout
        description={jobInfo?.Data?.JobTitle}
        title={`${jobInfo?.Data?.JobTitle} | ${jobInfo?.Data?.CompanyName}`}
        image={socialImage}
        status={jobInfo?.Status}
      >
        <Container>
          <div className={styles.searchdiv} style={{marginTop: isCompany === "beaconhousegroup" ? "40px" : isCompany === "tcs" ? "40px" : "20px"}}>
            <MainSearchSecond data={router.query} />
          </div>
          <UIHeading
            type="secondary"
            className={styles.jobdetailhead}
            level={3}
          >

            Job Detail
          </UIHeading>
        </Container>
        <div
          className={styles.jobDetailPageMain}
        >
          <Container>
            <Row>
              <Col xl={jobInfo?.Data?.Member_Applied == 1 ? 9 : 12}>
                {!Status && (
                  <div style={{ marginBottom: 20 }}>
                    <Alert
                      message={<UIText>The employer is no longer accepting applications for this job</UIText>}
                      type="error"
                      showIcon
                    />
                  </div>
                )}
                <JobInfoCard
                  info={jobInfo.Data}
                  wide={true}
                  jobStatus={Status}
                  //   loading={jobInfoLoading}
                />
              </Col>

              {jobInfo?.Data?.Member_Applied == 1 && (
                <Col className={style.ApplicationStatus} xl={3}>
                  <UIHeading level={3}>Application Status</UIHeading>
                  <Divider />
                  {jobInfo?.Data?.Member_JobHistoryInfo?.Status != 5 ? (
                    <Steps
                      progressDot
                      current={
                        jobInfo?.Data?.Member_JobHistoryInfo?.Status
                          ? parseInt(jobInfo?.Data?.Member_JobHistoryInfo?.Status)
                          : ""
                      }
                      direction="vertical"
                    >
                      <Step title="New" />
                      <Step title="In-Review" />
                      <Step title="Interview" />
                      <Step title="Offered" />
                      <Step title="Hired" />
                    </Steps>
                  ) : (
                    <>
                      <UIHeading level={4}>Rejected</UIHeading>
                    </>
                  )}
                </Col>
              )}
            </Row>
          </Container>
        </div>
      </MainLayout>
    </>
  );
}

export async function getServerSideProps({ req, res, query }) {
  try{
  let AccessToken = await getCookie("HireSide_Members_AccessToken", { req, res });
  const cookieCountryCode = await getCookie("countryCode", { req, res });
  const forwardedHost = req.headers["x-forwarded-host"];
  const requestHost = Array.isArray(forwardedHost)
    ? forwardedHost[0]
    : forwardedHost?.split(",")[0] || req.headers.host || "";
  const hostname = requestHost.trim().toLowerCase().split(":")[0];

  let countryCode = cookieCountryCode || "global";
  if (hostname === "talent.thecityschool.edu.pk") {
    countryCode = "tcs";
  } else if (hostname.endsWith(".hireside.com")) {
    countryCode = hostname.split(".")[0] || countryCode;
  } else if (hostname === "hireside.com" || hostname === "www.hireside.com") {
    countryCode = "global";
  }

  let moreParams = { req };
  let jobInfo = await GetJobInfo(query.jobdetail, AccessToken, moreParams, countryCode);
  return { props: { jobInfo } };
  }catch(e){
    console.error(e);
    return { props: { jobInfo: {Status: 0, Data : {}} } };
  }
}

export default jobDetail;
const useStyles = createUseStyles({
  ApplicationStatus: {
    background: "#fafafa",
    padding: "20px",
    boxShadow: "2px 2px 4px 1px #f3f2f2",
    borderRadius: "10px",
    backgroundColor: "#fdfdfd",
    border: "2px solid #eeeeee",
    height: "100%",
  },
});
